import { render, staticRenderFns } from "./ListDocuments.vue?vue&type=template&id=5d2735bc&scoped=true&"
import script from "./ListDocuments.vue?vue&type=script&lang=js&"
export * from "./ListDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ListDocuments.vue?vue&type=style&index=0&id=5d2735bc&scoped=true&lang=css&"
import style1 from "./ListDocuments.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2735bc",
  null
  
)

export default component.exports